window.currentLoopVariantId = null;

(function () {

    function hookLoop() {

        if (
            !window.LoopSubscriptions ||
            !window.LoopSubscriptions.handleLoopWidgetVariantIdChange
        ) {
            setTimeout(hookLoop, 200);
            return;
        }

        const original =
            window.LoopSubscriptions.handleLoopWidgetVariantIdChange;

        window.LoopSubscriptions.handleLoopWidgetVariantIdChange = function (productId, variantId) {

            console.log("✅ Loop Current Variant:", variantId);

            window.currentLoopVariantId = variantId;

            return original.apply(this, arguments);
        };

        console.log("✅ Loop Hook Installed");

    }

    hookLoop();

})();

(function () {

    console.log("========== Instant Subscription Debug Started ==========");

    function getSellingPlan(variantId) {

      console.log("Searching selling plan for Variant:", variantId);

      const script = document.querySelector('script[id^="selling_plans__"]');

      if (!script) {
        console.error("❌ selling_plans__ script NOT FOUND");
        return null;
      }

      try {

        const plans = JSON.parse(script.textContent);

        console.log("Selling Plans JSON:", plans);

        const match = plans.find(item => {
          console.log("Checking:", item);
          return String(item.variantId) === String(variantId);
        });

        console.log("Matched Plan:", match);

        return match ? match.sellingPlanId : null;

      } catch (e) {

        console.error("Selling Plan Parse Error", e);

        return null;

      }

    }

    document.addEventListener("click", function (e) {

      const btn = e.target.closest(
        'a[data-instant-action-type="add-to-instant-cart"]'
      );

      if (!btn) return;

      console.log("========== ADD TO CART CLICK ==========");

      e.preventDefault();
      e.stopImmediatePropagation();

      const form = document.querySelector(
        'form[data-instant-type="root"]'
      );

      console.log("Form:", form);

const variantId =
    window.currentLoopVariantId ||
    form?.querySelector('input[name="id"]')?.value ||
    form?.dataset.instantFormVariantId ||
    btn.dataset.instantActionVariantId;

      console.log("Current Variant:", variantId);

      let quantity = 1;

      const qtyInput = document.querySelector(
        'input[name="quantity"]:not([disabled])'
      );

      if (qtyInput) {
        quantity = parseInt(qtyInput.value, 10) || 1;
      }

      console.log("Quantity:", quantity);

    const sellingPlanInput = form?.querySelector('input[name="selling_plan"]');

    const sellingPlan = sellingPlanInput?.value || null;

    const body = {
    id: Number(variantId),
    quantity: quantity
    };

    if (sellingPlan) {
    body.selling_plan = Number(sellingPlan);
    }

    console.log("Variant:", variantId);
    console.log("Selling Plan:", sellingPlan);
    console.log("Request Body:", body);

      console.log("Final Request Body:", body);

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(body)
      })
        .then(async (res) => {

          console.log("Status:", res.status);

          const text = await res.text();

          console.log("Response:", text);

          if (!res.ok) {
            throw new Error(text);
          }

          return fetch("/cart.js");

        })
        .then((res) => res.json())
        .then((cart) => {

          console.log("Cart Updated:", cart);

          updateCartCount(cart.item_count);

          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: cart
            })
          );

          setTimeout(() => {

            console.log("Opening Cart Drawer");

            openCartDrawer();

          }, 300);

        })
        .catch((err) => {

          console.error("ADD TO CART ERROR:", err);

        });

    }, true);

  })();




const form = document.querySelector('form[data-instant-type="root"]');


const variantId = getCurrentVariantId();

console.log(variantId);
const sellingPlan = form.querySelector('input[name="selling_plan"]')?.value;

const quantity =
  parseInt(form.querySelector('input[name="quantity"]')?.value || 1, 10);

const body = {
  id: Number(variantId),
  quantity: quantity
};

if (sellingPlan) {
  body.selling_plan = Number(sellingPlan);
}

console.log(body);

function updateCartCount(count) {

    console.log("Updating Cart Count:", count);

    document
      .querySelectorAll(
        ".cart-count-bubble span[aria-hidden='true'], .cart-count-bubble .visually-hidden"
      )
      .forEach((el) => (el.textContent = count));

    const cartIcon = document.getElementById("cart-icon-bubble");

    if (cartIcon) {
      cartIcon.classList.toggle("header__cart--empty", count === 0);
    }

}

function openCartDrawer() {

console.log("Trying to Open Cart Drawer");

const cartBtn = document.querySelector(
    "[data-open-cart], #cart-icon-bubble"
);

console.log("Drawer Button:", cartBtn);

if (cartBtn) {
    cartBtn.click();
} else {
    console.error("Cart Drawer Button Not Found");
}

}

function getCurrentVariantId() {

    const form = document.querySelector('form[data-instant-type="root"]');

    // 1. Hidden input (best)
    const inputId = form?.querySelector('input[name="id"]')?.value;
    if (inputId) return inputId;

    // 2. Instant dataset
    const datasetId = form?.dataset.instantFormVariantId;
    if (datasetId) return datasetId;

    // 3. URL
    const urlId = new URLSearchParams(window.location.search).get("variant");
    if (urlId) return urlId;

    return null;
}